import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary-800 text-secondary-300 mt-auto">
      <div className="container-custom py-8">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-6">
          {/* Company Info */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">ETN Platform</h3>
            <p className="text-sm mb-2">금융 투자상품(ETN) 정보 제공 플랫폼</p>
            <p className="text-sm">투자자에게 신뢰할 수 있는 금융 정보를 제공합니다.</p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold text-base mb-4">바로가기</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="hover:text-white transition-colors">
                  금융상품
                </Link>
              </li>
              <li>
                <Link to="/notice" className="hover:text-white transition-colors">
                  공시정보
                </Link>
              </li>
              <li>
                <Link to="/admin/login" className="hover:text-white transition-colors">
                  관리자
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-semibold text-base mb-4">문의</h4>
            <ul className="space-y-2 text-sm">
              <li>이메일: contact@etnplatform.com</li>
              <li>전화: 02-1234-5678</li>
              <li>운영시간: 평일 09:00 - 18:00</li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-secondary-700 pt-6">
          {/* Legal Links */}
          <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-4">
            <div className="flex flex-wrap gap-4 text-sm mb-4 md:mb-0">
              <Link to="#" className="hover:text-white transition-colors">
                이용약관
              </Link>
              <Link to="#" className="hover:text-white transition-colors font-semibold">
                개인정보처리방침
              </Link>
              <Link to="#" className="hover:text-white transition-colors">
                투자유의사항
              </Link>
            </div>
          </div>

          {/* Copyright */}
          <div className="text-sm text-secondary-400">
            <p>© {currentYear} ETN Platform. All rights reserved.</p>
            <p className="mt-2">본 사이트는 React + Tailwind CSS로 제작된 프론트엔드 목업입니다.</p>
          </div>
        </div>

        {/* Investment Warning */}
        <div className="mt-6 p-4 bg-secondary-900 rounded-lg">
          <p className="text-xs text-secondary-400">
            <strong className="text-accent-red-400">투자 유의사항:</strong> 금융투자상품은
            예금자보호법에 따라 보호되지 않으며, 투자 원금 손실이 발생할 수 있습니다. 투자 전
            상품설명서 및 약관을 반드시 확인하시기 바랍니다.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
